import { render, staticRenderFns } from "./PairPage.vue?vue&type=template&id=e747b706&scoped=true&"
import script from "./PairPage.vue?vue&type=script&lang=js&"
export * from "./PairPage.vue?vue&type=script&lang=js&"
import style0 from "./PairPage.vue?vue&type=style&index=0&id=e747b706&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e747b706",
  null
  
)

export default component.exports